<template>
  <paginated-data-table
    ref="table"
    :headers="headers"
    :query="query"
    :graphql-uri="$microservicesUrls['campaigns']"
    query-name="emailTemplates"
    :query-main-property-name="'emailTemplates'"
    :query-variables="queryVariables"
  >
    <template v-slot:item="{ item }">
      <tr class="cursor-pointer" @click="toggleTemplate(item)">
        <td>
          <v-simple-checkbox
            :value="localSelectedTemplate && localSelectedTemplate._id === item._id"
            color="primary"
            :ripple="false"
            @input="toggleTemplate(item)"
          />
        </td>
        <td>{{ item.title }}</td>
        <td>{{ item.updated_at | data }}</td>
        <td>
          <v-menu bottom origin="center center" transition="scale-transition">
            <template v-slot:activator="{ on }">
              <mf-button type="icon" icon="more_vert" color="cinza-0" v-on:click.native="on.click" />
            </template>

            <v-list>
              <v-list-item @click="deleteTemplate(item._id)">
                <v-list-item-title>Apagar template</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </td>
      </tr>
    </template>
  </paginated-data-table>
</template>

<script>
import { DateTime } from 'luxon'
import { QUERY_LIST_TEMPLATES, MUTATION_DELETE_TEMPLATES } from '@/modules/campanhas/campanhas-email/graphql'

export default {
  components: {
    PaginatedDataTable: () => import('@/components/PaginatedDataTable.vue'),
  },

  filters: {
    data(value) {
      return DateTime.fromISO(value).toFormat('dd/MM/yyyy HH:mm:ss')
    },
  },
  props: {
    search: {
      type: String,
    },
    selectedTemplate: {
      type: Object,
      default: () => {},
    },
  },

  computed: {
    localSelectedTemplate: {
      get() {
        return this.selectedTemplate
      },
      set(value) {
        this.$emit('update:selectedTemplate', value)
      },
    },
    queryVariables() {
      return {
        search: this.search,
      }
    },
    query() {
      return QUERY_LIST_TEMPLATES
    },
    headers() {
      return [
        {
          value: '',
          sortable: false,
          width: '5%',
        },
        {
          text: 'Nome',
          value: 'title',
          width: '50%',
        },
        {
          text: 'Última Atualização',
          value: 'updated_at',
          width: '40%',
        },
        {
          value: '',
          sortable: false,
          width: '5%',
        },
      ]
    },
  },

  methods: {
    toggleTemplate(template) {
      this.localSelectedTemplate = template
    },
    async deleteTemplate(templateId) {
      try {
        await this.$apollo.mutate({
          mutation: MUTATION_DELETE_TEMPLATES,
          variables: {
            _id: templateId,
          },
          context: {
            uri: this.$microservicesUrls['campaigns'],
          },
        })
        this.$snackbar({ message: 'Template de e-mail apagado com sucesso.', snackbarColor: 'success' })
        this.refresh()
      } catch (e) {
        console.warn(e)
        this.$snackbar({ message: 'Erro ao apagar template de e-mail.', snackbarColor: 'error' })
      }
    },
    refresh() {
      this.$refs.table.reset()
    },
  },
}
</script>
